


















































import Vue from "vue";
import Modal from "@/components/Modal/Modal.vue";
import DoughnutChart from "@/components/Chart/DoughnutChart.vue";
import { store } from "@/store/store";
import { Category } from "@/store/modules/Category/interface";

interface DeviceStatus {
  name: string;
  color: string;
  count: number;
}

interface DeviceMainStatus {
  name: string;
  color: string;
  count: number;
}

interface DeviceCategoryModalData {
  actual_category: Category;
  device_status: Array<DeviceStatus>;
  device_main_status: Array<DeviceMainStatus>;
  data_main: any;
  data: any;
}

export default Vue.extend({
  name: "DeviceCategoryModal",
  components: { Modal, DoughnutChart },
  props: {
    category_id: {
      type: String,
      default: ""
    },
    should_display: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => undefined
    }
  },
  data(): DeviceCategoryModalData {
    return {
      actual_category: store.getters.CATEGORY_BY_ID[this.category_id],
      device_status: [],
      device_main_status: [],
      data: {},
      data_main: {}
    };
  },
  mounted() {
    this.countDeviceStatus();
    this.dataCollection();
  },
  // to refacto ...
  methods: {
    countDeviceStatus(): void {
      const device_for_category = store.getters.DEVICE_ALL_ID.filter(
        (device_id) => store.getters.DEVICE_BY_ID[device_id].category === this.category_id
      );
      device_for_category.forEach((device_id) => {
        let state_device: string = store.getters.DEVICE_BY_ID[device_id].state;
        let state_name: string = store.getters.STATE_BY_ID[state_device].name;
        let device_status = this.device_status.find((status) => status.name === state_name);
        if (device_status) device_status.count += 1;
        else
          this.device_status.push({
            name: state_name,
            count: 1,
            color: store.getters.STATE_BY_ID[state_device].color
          });
      });
      device_for_category.forEach((device_id) => {
        let state_device: string = store.getters.DEVICE_BY_ID[device_id].state;
        let main_state_id: string = store.getters.STATE_BY_ID[state_device].main_state;
        let main_state_name: string = store.getters.MAIN_STATE_BY_ID[main_state_id].name;
        let device_status = this.device_main_status.find((status) => status.name === main_state_name);
        if (device_status) device_status.count += 1;
        else
          this.device_main_status.push({
            name: main_state_name,
            count: 1,
            color: store.getters.MAIN_STATE_BY_ID[main_state_id].color
          });
      });
    },
    dataCollection(): any {
      this.data = {
        fontColor: "#ffffff",
        labels: this.device_status.map((device) => device.name),
        datasets: [
          {
            label: "STATUT DES APPAREILS",
            data: this.device_status.map((device) => device.count),
            backgroundColor: this.device_status.map((device) => device.color)
          }
        ]
      };
      this.data_main = {
        fontColor: "#ffffff",
        labels: this.device_main_status.map((device) => device.name),
        datasets: [
          {
            label: "STATUT DES APPAREILS",
            data: this.device_main_status.map((device) => device.count),
            backgroundColor: this.device_main_status.map((device) => device.color)
          }
        ]
      };
    }
  },
  computed: {
    title(): string {
      return `Statuts pour la catéogie - ${this.actual_category.name} `;
    }
  }
});
